import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { CSVLink } from "react-csv";
import apiUrl from "../Apiurl";
import UltimeModificheUtenteLista from './UltimeModificheUtenteLista';
import associaImmagineENomeANomeUtente from '../interfaccia/funzioniComuni/associaImmagineENomeANomeUtente';
import stilePulsanti from '../interfaccia/stilePulsanti';

function UltimeModificheUtente({
  nomeUtente,
  utente,
  setProductFunction,
  data1,
  data2,
  misure,
  onListaAggiornata
}) {

  const className = 'w-100 pa3 sfondoBiancoTema br3 shadow-1';

  const {pathImmagine, nomeDisplay} = associaImmagineENomeANomeUtente(nomeUtente, utente.username)

  const { user, /* isAuthenticated, */ getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  const [lista, setLista] = useState([]);

  const headers = [
                  { label: "codVS", key: "codVS" },
                  { label: "brand", key: "brand" },
                  { label: "shortName", key: "shortName" },
                  { label: "data", key: "data" }
                ];

  useEffect(() => {
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }

    fetch(apiUrl + "/prodotti/get/lavorazioniByUtenteByDate/" + nomeUtente + "/" + data1 + "/" + data2, { headers: { Authorization: "Bearer " + token } })
      .then(resp => resp.json())
      .then(data => setLista(data))
  }, [token, data1, data2, nomeUtente]);

  useEffect(() => {
    if (typeof onListaAggiornata === "function") {
      onListaAggiornata(nomeUtente, lista);
    }
  }, [lista, nomeUtente, onListaAggiornata]);


  useEffect(() => {
    const getUserMetadata = async () => {

      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };

    getUserMetadata();


  }, [getAccessTokenSilently, user?.sub]);

  return (
    <div className={className}>
      <h3 className='flex items-center justify-center'>
        {/* {nomeUtente === utente.username && utente.emoji && <span className='mr2'>{utente.emoji}</span>} */}
        <div class="pa1 tc">
          <img
            src={pathImmagine}
            className="br-100 dib mr3 wpx-100"
            alt="foto utente"></img>
        </div>
        <div>{nomeDisplay}</div>
      </h3>
      <UltimeModificheUtenteLista lista={lista} setProductFunction={setProductFunction} utente={utente} misure={misure} />
        <div className='tc mt3 mb3'>
        <CSVLink 
            data={lista} 
            headers={headers} 
            separator={";"} 
            enclosingCharacter={``} 
            className={stilePulsanti.buttonClassesWhite} 
            target="_blank" 
            filename={nomeDisplay+" "+data1+"_"+data2+".csv"}>
              scarica csv
        </CSVLink>
        </div>
    </div>
  )
}

export default UltimeModificheUtente;
